 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      GL Account No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryGlAcctNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap v-if="objData === 'screen_2'">
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.glacctNo"
                            :label="filtersGlAcctNoLabel.glacctNo"
                            :error-messages="errors.collect('filterGlAcctNo.glacctNo')"
                            data-vv-name="filterGlAcctNo.glacctNo"
                            :data-vv-as="filtersGlAcctNoLabel.glacctNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.description"
                            :label="filtersGlAcctNoLabel.description"
                            :error-messages="errors.collect('filterGlAcctNo.description')"
                            data-vv-name="filterGlAcctNo.description"
                            :data-vv-as="filtersGlAcctNoLabel.description"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.branch"
                            :label="filtersGlAcctNoLabel.branch"
                            :error-messages="errors.collect('filterGlAcctNo.branch')"
                            data-vv-name="filterGlAcctNo.branch"
                            :data-vv-as="filtersGlAcctNoLabel.branch"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.fund"
                            :label="filtersGlAcctNoLabel.fund"
                            :error-messages="errors.collect('filterGlAcctNo.fund')"
                            data-vv-name="filterGlAcctNo.fund"
                            :data-vv-as="filtersGlAcctNoLabel.fund"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.acctNoSfx"
                            :label="filtersGlAcctNoLabel.acctNoSfx"
                            :error-messages="errors.collect('filterGlAcctNo.acctNoSfx')"
                            data-vv-name="filterGlAcctNo.acctNoSfx"
                            :data-vv-as="filtersGlAcctNoLabel.acctNoSfx"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap v-else>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.glacctNo"
                            :label="filtersGlAcctNoLabel.glacctNo"
                            :error-messages="errors.collect('filterGlAcctNo.glacctNo')"
                            data-vv-name="filterGlAcctNo.glacctNo"
                            :data-vv-as="filtersGlAcctNoLabel.glacctNo"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearGlAcctNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doGlAcctNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="objData === 'screen_2'">
        <v-data-table
          :headers="glAcctNoHeaders2"
          :items="glAcctNoItems"
          v-bind:options.sync="paginationGlAcctNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsGlAcctNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.branch }}</td>
              <td>{{ row.item.glacctNo }}</td>
              <td>{{ row.item.fund }}</td>
              <td>{{ row.item.suffix }}</td>
              <td>{{ row.item.description }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignGlAcctNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-else>
        <v-data-table
          :headers="glAcctNoHeaders"
          :items="glAcctNoItems"
          v-bind:options.sync="paginationGlAcctNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsGlAcctNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.glacctNo }}</td>
              <td>{{ row.item.description }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignGlAcctNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationGlAcctNo: {
        page: 1
      }
    }
  },
  mounted() {
    this.doClearGlAcctNoFilters()
  },
  methods: {
    closeDialog() {
      this.filtersGlAcctNo.glacctNo = ''
      this.filtersGlAcctNo.branch = ''
      this.filtersGlAcctNo.description = ''
      this.filtersGlAcctNo.fund = ''
      this.filtersGlAcctNo.acctNoSfx = ''
      this.$emit('close')
    },
    doClearGlAcctNoFilters() {
      this.filtersGlAcctNo.glacctNo = ''
      this.filtersGlAcctNo.branch = ''
      this.filtersGlAcctNo.description = ''
      this.filtersGlAcctNo.fund = ''
      this.filtersGlAcctNo.acctNoSfx = ''
      if (this.objData !== '') {
        this.filtersGlAcctNo.yrClosed = '0'
      }
      this.fetchGlAcctNoData()
    },
    doGlAcctNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryGlAcctNoFilterForm').then((result) => {
        if (result) {
          this.paginationGlAcctNo.page = 1
          if (this.objData !== '') {
            this.filtersGlAcctNo.yrClosed = '0'
          }
          this.fetchGlAcctNoData()
        }
      })
    },
    assignGlAcctNo(data) {
      // Use $emit to call parent GL Account No page method assignGlAcctNo and pass the value
      this.$emit('assign-gl-acct-no', data.glacctNo)
      this.$emit('assign-gl-acct-info', data)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin],
  props: {
    objData: {
      type: String,
      default: ''
    }
  }
}
</script>
